function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, forwardRef } from "react";
import { Container, Table } from "react-bootstrap";
import { Image, Row, Col, Alert, Space } from "antd";
import { GeoAltFill, TelephoneFill, Globe, Bank2, EnvelopeAtFill } from "react-bootstrap-icons";
import { NumberToLetter } from 'convertir-nombre-lettre';
import Moment from "react-moment";
import moment from "moment";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BillDisplay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$candidates = _ref.candidates,
    candidates = _ref$candidates === void 0 ? [] : _ref$candidates,
    company = _ref.company,
    _ref$from = _ref.from,
    from = _ref$from === void 0 ? null : _ref$from,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? null : _ref$to;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    a1Array = _useState2[0],
    setA1Array = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    a2Array = _useState4[0],
    setA2Array = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    b1Array = _useState6[0],
    setB1Array = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    b2Array = _useState8[0],
    setB2Array = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    b3Array = _useState0[0],
    setB3Array = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    b4Array = _useState10[0],
    setB4Array = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    b5Array = _useState12[0],
    setB5Array = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    peArray = _useState14[0],
    setPeArray = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    vaArray = _useState16[0],
    setVaArray = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    dayArray = _useState18[0],
    setDayArray = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    ptArray = _useState20[0],
    setPtArray = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    totalAmount = _useState22[0],
    setTotalAmount = _useState22[1];
  var priceScheme = [{
    category: 0,
    price: 2800000
  }, {
    category: 1,
    price: 3500000
  }, {
    category: 2,
    price: 500000
  }, {
    category: 3,
    price: 500000
  }, {
    category: "A1",
    price: 640000
  }, {
    category: "A2",
    price: 540000
  }, {
    category: "B1",
    price: 1185000
  }, {
    category: "B2",
    price: 1450000
  }, {
    category: "B3",
    price: 1295000
  }, {
    category: "B4",
    price: 2630000
  }, {
    category: "B5",
    price: 2530000
  }];
  useEffect(function () {
    var ta = 0;
    candidates.forEach(function (c) {
      if (c.category == "0") {
        if (c.reason == "0") {
          setVaArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == 0;
          })[0].price;
          return;
        }
        if (c.reason == "1") {
          setPeArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == 1;
          })[0].price;
          return;
        }
        if (c.reason == "2") {
          setDayArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == 2;
          })[0].price;
          return;
        }
        if (c.reason == "3") {
          setPtArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [c]);
          });
          ta += priceScheme.filter(function (s) {
            return s.category == 3;
          })[0].price;
          return;
        }
      }
      if (c.category == "A1") {
        setA1Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "A1";
        })[0].price;
        return;
      }
      if (c.category == "A2") {
        setA2Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "A2";
        })[0].price;
        return;
      }
      if (c.category == "B1") {
        setB1Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B1";
        })[0].price;
        return;
      }
      if (c.category == "B2") {
        setB2Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B2";
        })[0].price;
        return;
      }
      if (c.category == "B3") {
        setB3Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B3";
        })[0].price;
        return;
      }
      if (c.category == "B4") {
        setB4Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B4";
        })[0].price;
        return;
      }
      if (c.category == "B5") {
        setB5Array(function (prev) {
          return [].concat(_toConsumableArray(prev), [c]);
        });
        ta += priceScheme.filter(function (s) {
          return s.category == "B5";
        })[0].price;
        return;
      }
    });
    setTotalAmount(ta);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    id: "printable",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: {
            span: 12
          },
          md: {
            span: 12
          },
          sm: {
            span: 24
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#F7F2F5",
              borderRadius: "5px",
              padding: "22px",
              border: "none"
            },
            children: [/*#__PURE__*/_jsx(Image, {
              preview: false,
              src: "/drawables/emgl.png",
              width: "190px"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GeoAltFill, {
                  size: 17
                }), " "]
              }), " Conakry, Kip\xE9 - Kaporo, Rep. Guin\xE9e", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(TelephoneFill, {
                size: 17
              }), " + 224-621 724921 ", /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx(Globe, {
                size: 17
              }), " www.medviegn.com"]
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 11,
            offset: 1
          },
          md: {
            span: 11,
            offset: 1
          },
          sm: {
            span: 24
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "5px",
              padding: "22px",
              border: "2px solid #A9675C"
            },
            children: [/*#__PURE__*/_jsxs("h2", {
              children: [/*#__PURE__*/_jsxs("b", {
                children: ["FACTURE N\xBA: ", company.short_name + "0" + (moment().month() + 1) + moment().year()]
              }), " ", /*#__PURE__*/_jsx("br", {})]
            }), /*#__PURE__*/_jsx("b", {
              children: "INFOS CLIENT"
            }), /*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx("b", {
                children: company.label
              })
            }), from && to && /*#__PURE__*/_jsxs("b", {
              children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
                date: from,
                format: "DD/MM/YYYY"
              }), " au ", /*#__PURE__*/_jsx(Moment, {
                date: to,
                format: "DD/MM/YYYY"
              })]
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: {
            span: 24
          },
          children: [/*#__PURE__*/_jsxs(Table, {
            responsive: true,
            striped: true,
            bordered: true,
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "D\xE9signation"
                }), /*#__PURE__*/_jsx("th", {
                  children: "PU. (GNF)"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Qte"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Montant (GNF)"
                })]
              })
            }), /*#__PURE__*/_jsxs("tbody", {
              children: [vaArray.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales annuelles"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == 0;
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: vaArray.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == 0;
                  })[0].price * vaArray.length).toLocaleString("Fr")
                })]
              }, "0"), peArray.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales de pre-ambauche"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == 1;
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: peArray.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == 1;
                  })[0].price * peArray.length).toLocaleString("Fr")
                })]
              }, "1"), dayArray.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales de travailleurs journaliers"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == 2;
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: dayArray.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == 2;
                  })[0].price * dayArray.length).toLocaleString("Fr")
                })]
              }, "2"), ptArray.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales permis de travail"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == 3;
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: ptArray.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == 3;
                  })[0].price * ptArray.length).toLocaleString("Fr")
                })]
              }, "3"), a1Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type A1"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "A1";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: a1Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "A1";
                  })[0].price * a1Array.length).toLocaleString("Fr")
                })]
              }, "A1"), a2Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type A2"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "A2";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: a2Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "A2";
                  })[0].price * a2Array.length).toLocaleString("Fr")
                })]
              }, "A2"), b1Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type B1"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "B1";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: b1Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "B1";
                  })[0].price * b1Array.length).toLocaleString("Fr")
                })]
              }, "B1"), b2Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type B2"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "B2";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: b2Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "B2";
                  })[0].price * b2Array.length).toLocaleString("Fr")
                })]
              }, "B2"), b3Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type B3"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "B3";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: b3Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "B3";
                  })[0].price * b3Array.length).toLocaleString("Fr")
                })]
              }, "B3"), b4Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type B4"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "B4";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: b4Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "B4";
                  })[0].price * b4Array.length).toLocaleString("Fr")
                })]
              }, "B4"), b5Array.length > 0 && /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Visites m\xE9dicales type B5"
                }), /*#__PURE__*/_jsx("td", {
                  children: priceScheme.filter(function (s) {
                    return s.category == "B5";
                  })[0].price.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: b5Array.length.toLocaleString("Fr")
                }), /*#__PURE__*/_jsx("td", {
                  children: (priceScheme.filter(function (s) {
                    return s.category == "B5";
                  })[0].price * b5Array.length).toLocaleString("Fr")
                })]
              }, "B5")]
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "TOTAL (GNF) : "
            }), " ", totalAmount.toLocaleString("Fr")]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("b", {
              style: {
                fontStyle: "italic"
              },
              children: ["Arr\xEAt\xE9e la pr\xE9sente facture \xE0 la somme de ", NumberToLetter(totalAmount), " Francs Guin\xE9ens"]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              lg: {
                span: 10,
                offset: 14
              },
              md: {
                span: 10,
                offset: 14
              },
              sm: {
                span: 10,
                offset: 14
              },
              children: [/*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "La comptabilit\xE9"
                })
              }), /*#__PURE__*/_jsx(Image, {
                src: "/drawables/compsign.png",
                preview: false,
                width: "280px"
              })]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#F3F2EE",
              borderRadius: "5px",
              padding: "6px",
              boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
            },
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx("b", {
                children: "MEDVIE, "
              }), /*#__PURE__*/_jsx(GeoAltFill, {
                size: "16"
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "Kip\xE9"
              }), /*#__PURE__*/_jsx(EnvelopeAtFill, {
                size: 16
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "info@centremedvie.com"
              }), /*#__PURE__*/_jsx(Globe, {
                size: 16
              }), " ", /*#__PURE__*/_jsx("span", {
                children: "www.cliniquemedvie.com"
              })]
            })
          })
        })
      })]
    })
  });
});
export default BillDisplay;